import React from "react";

// Style
import { Svg } from "./styles";

const Rhomboid = ({ size = 60 }) => {
  // <path d="M 0 0 L 0 0 H 300 V 100 H 30" />;
  const displacement = size/5;
  return (
    <Svg height={size} width={size}>
      <polygon points={displacement+",0 "+size+",0 "+(size-displacement)+","+size+" 0,"+size} />
      Sorry, your browser does not support inline SVG.
    </Svg>
  );
};

export default Rhomboid;
